import TopicList from "@/components/TopicList";
import { getLikedTopics } from "@/services";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Else, If, Then } from "react-if";
import Empty from "../Empty";

export default function MyFavoriteTopicList({ user, initLikesTopics }) {
  const [dataSource, setDataSource] = useState(initLikesTopics || []);
  const [hasMore, setHasMore] = useState(true);
  const maxRef = useRef(initLikesTopics?.[0]?.seq || 0);
  const initRef = useRef(initLikesTopics?.length > 0);

  const queryAction = useMemo(() => {
    // 如果服务端有数据就不做初始化
    if (initRef.current) {
      setDataSource([]);
      setHasMore(true);
      maxRef.current = 0;
      initRef.current = true;
    }

    return async () => {
      const result = await getLikedTopics({
        urlname: user.urlname,
        ...(maxRef.current ? { max: maxRef.current } : null),
        limit: 20,
      });
      if (result?.user?.likes_topics?.length <= 0) {
        setHasMore(false);
      }
      setDataSource((dataSource) =>
        dataSource.concat(
          result?.user?.likes_topics.map((topic) => ({
            title: topic?.detail?.banner?.materials?.[0]?.title,
            urlname: topic?.urlname,
            url: `/topics/${topic?.urlname}`,
            file: topic?.preview?.pins?.[0]?.file,
            keyword_id: topic?.detail?.id,
            seq: topic?.seq,
            following: topic?.following,
            liked: topic?.liked,
          })) || []
        )
      );
    };
  }, [user]);

  const onLoadMore = useCallback(() => {
    if (dataSource.length > 0) {
      const last = dataSource[dataSource.length - 1];
      maxRef.current = last.seq;
      queryAction();
    }
  }, [dataSource, queryAction]);

  useEffect(() => {
    queryAction();
  }, [queryAction]);

  return (
    <If condition={dataSource.length > 0 || hasMore}>
      <Then>
        <TopicList
          dataSource={dataSource}
          hasMore={hasMore}
          onLoadMore={onLoadMore}
          isExplore={false}
          showLike={true}
        />
      </Then>
      <Else>
        <Empty
          title="还没有喜欢的主题哦～"
          imageUrl="https://st0.dancf.com/static/02/202209200949-e485.png"
        />
      </Else>
    </If>
  );
}
